import { DateTime } from 'luxon';
import type { MaskFormValue } from '@/modules/document/document-master/types/mask.ts';
import { stripMaskStructuralBlanks } from '@/modules/ui/utils/mask-caret.util.ts';

export function mapMaskFormValue(value: MaskFormValue | undefined) {
  if (!value && value !== 0) {
    return null;
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string') {
    return stripMaskStructuralBlanks(value);
  }

  if (value instanceof DateTime) {
    return value.toSQLDate();
  }

  return value.code;
}
